import defaultUnitFilters from './filters';

const reduceByLabel = (p, c) => ({ ...p, [c.value]: c });

/**
 * The storage type dropdown has two hardcoded options,
 * self-storage and vehicle-storage, that are used to swap between
 * showing vehicle sizes and self-storage sizes.
 */


export const storageTypeOptions = [
	{
		label: 'Self-Storage',
		value: 'storage'
	},
	{
		label: 'Vehicle Storage',
		value: 'vehicle'
	}
].reduce(reduceByLabel, {});

/**
 * Beyond picking from the hardcoded options,
 * the user can select the usual amenities.
 */

export const amenityOptions = [
	...defaultUnitFilters.storage.amenities.options
].reduce(reduceByLabel, {});

export const storageSizeOptions = [
	{ value: 'all-sizes', label: 'All Storage Sizes' },
	...defaultUnitFilters.storage.size.options
].reduce(reduceByLabel, {});
export const vehicleSizeOptions = [
	{ value: 'all-sizes', label: 'All Storage Sizes' },
	...defaultUnitFilters.vehicle.length.options
].reduce(reduceByLabel, {});
